<style scoped>

</style>
<template>
  <div>
    <Tabs type="card">
      <TabPane
        label="课程列表"
        name="course"
      >
        <CourseList />
      </TabPane>
      <TabPane
        label="课程数据定义"
        name="course-data"
      >
        <CourseDataTypeList />
      </TabPane>
    </Tabs>
  </div>
</template>
<script route="/course_report/setting">
  import CourseList from './components/course_list';
  import CourseDataTypeList from './components/course_data_type_list';
  export default {
    /* router_info_start */
    router_info: '/course_report/setting',
    /* router_info_end */
    components: { CourseList, CourseDataTypeList },
    data() {
      return {
        //
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      //
    }
  }
</script>
